import React from 'react';
import Cookies from 'js-cookie';
import confetti from 'canvas-confetti';
import styles from './LiveResume.module.css';
import * as utils from '../../utils/utils';
import Sidebar from '../Sidebar/Sidebar';

const PROCESSING_STEPS = ['structurizing', 'verifying', 'generating q&a for verification'];
const MAX_VOUCHERS = 2;
const MAX_VIDEO_SECONDS = 30;

export default class LiveResume extends React.Component {

	constructor(props) {
		super(props);

		this.screens = {
			Composer: 1,
			VerificationChoice: 2,
			VouchFriends: 3,
			VideoVerification: 4,
			Processing: 5,
			Verification: 6,
			Failure: 7,
			Success: 8,
			StructureSummary: 9,
		};

		this.processingMessageTimer = null;
		this.processingAdvanceTimer = null;
		this.questionTimer = null;
		this.answerAdvanceTimer = null;
		this.videoTimer = null;
		this.videoPreviewRef = React.createRef();
		this.videoStream = null;
		this.videoRecorder = null;
		this.videoChunks = [];

		this.state = {
			currentScreen: this.screens.Composer,

			// liveResumeText: 'learned about knex.js migrations',
			// liveResumeText: 'as a referral coordinator, i sent 22 referrals today to different doctors from UNLV Health center in my 8 hour shift',
			// liveResumeText: 'worked with seed files in knex.js with node.js backend',
			liveResumeText: '',
			entities: [],
			selectedUserEntityID: '',
			verificationQuestions: [],
			verificationAnswersByQuestionID: {},
			selectedAnswersByQuestionID: {},
			learningIntentQuestionIDs: [],
			verificationMisses: [],
			currentLiveResumeID: 0,
			verificationMethod: '',
			gainedStructure: null,
			isStructureLoading: false,
			structureLoadError: '',
			peopleForVouch: [],
			selectedVouchUserIDs: [],
			vouchInviteEmails: ['', ''],
			isPeopleLoading: false,
			vouchSuccessText: '',
			videoPermissionState: 'idle',
			isVideoRecording: false,
			videoSecondsLeft: MAX_VIDEO_SECONDS,
			recordedVideoBlob: null,
			recordedVideoURL: '',
			recordedVideoMimeType: '',
			videoSuccessText: '',

			isLoading: false,
			isEntityLoading: true,
			errorText: '',
			verificationErrorText: '',
			processingMessageIndex: 0,
			currentQuestionIndex: 0,
			selectedAnswerIndexes: [],
			questionTimeLeft: 60,
		};
	}

	componentDidMount() {
		if (!utils.isLoggedIn()) {
			window.location.href = '/signin';
			return;
		}

		this.loadMyEntities();
	}

	componentWillUnmount() {
		this.clearAllVerificationTimers();
		this.teardownVideoVerification();
	}

	getUserIDKey = () => {
		if (utils.isDev) {
			return 'User-Id-Dev';
		}

		return 'User-Id';
	};

	answerLettersToIndexes = (rawAnswer) => {
		const normalized = String(rawAnswer || '')
			.trim()
			.toUpperCase();

		if (!normalized) {
			return [];
		}

		const letterToIndex = {
			A: 0,
			B: 1,
			C: 2,
			D: 3,
			E: 4,
		};

		// Accept formats like "A,C", "A and C", "A / C", "A. C", and even "AC".
		let tokens = normalized.match(/\b[ABCDE]\b/g) || [];

		if (!tokens.length) {
			tokens = normalized.split('').filter((char) => Object.prototype.hasOwnProperty.call(letterToIndex, char));
		}

		const indexes = tokens
			.map((item) => letterToIndex[item])
			.filter((item) => Number.isInteger(item));

		return Array.from(new Set(indexes)).sort((a, b) => a - b);
	};

	setVerificationQuestions = ({ liveResumeID, questionRows }) => {
		const normalizedQuestionRows = Array.isArray(questionRows) ? questionRows : [];

		const verificationQuestions = normalizedQuestionRows.map((row) => ({
			questionID: Number(row.userEntityLiveResumeChoiceQuestionId),
			question: row.question || '',
			options: [row.optionA, row.optionB, row.optionC, row.optionD].map((optionValue) => optionValue || ''),
		}));

		this.setState({
			verificationQuestions,
			verificationAnswersByQuestionID: {},
			selectedAnswersByQuestionID: {},
			learningIntentQuestionIDs: [],
			verificationMisses: [],
			currentLiveResumeID: liveResumeID,
			verificationMethod: '',
			peopleForVouch: [],
			selectedVouchUserIDs: [],
			vouchInviteEmails: ['', ''],
			vouchSuccessText: '',
		});
	};

	getCleanVouchInviteEmails = () => {
		const emails = Array.isArray(this.state.vouchInviteEmails) ? this.state.vouchInviteEmails : [];

		return Array.from(new Set(
			emails
				.map((item) => String(item || '').trim().toLowerCase())
				.filter((item) => item !== '')
		));
	};

	getSelectedVouchPeople = () => {
		const selectedSet = new Set(this.state.selectedVouchUserIDs || []);
		const people = Array.isArray(this.state.peopleForVouch) ? this.state.peopleForVouch : [];

		return people.filter((person) => selectedSet.has(person.userId));
	};

	getCurrentVouchCount = () => {
		const selectedCount = this.getSelectedVouchPeople().length;
		const inviteEmailCount = this.getCleanVouchInviteEmails().length;
		return selectedCount + inviteEmailCount;
	};

	areAnswerSetsEqual = (leftIndexes, rightIndexes) => {
		const left = Array.isArray(leftIndexes) ? Array.from(new Set(leftIndexes)).sort((a, b) => a - b) : [];
		const right = Array.isArray(rightIndexes) ? Array.from(new Set(rightIndexes)).sort((a, b) => a - b) : [];

		if (left.length !== right.length) {
			return false;
		}

		for (let index = 0; index < left.length; index += 1) {
			if (left[index] !== right[index]) {
				return false;
			}
		}

		return true;
	};

	getQueryUserEntityID = () => {
		const params = new URLSearchParams(window.location.search);
		const value = Number(params.get('userEntityID'));

		if (Number.isInteger(value) && value > 0) {
			return value;
		}

		return null;
	};

	loadMyEntities = () => {
		this.setState({
			isEntityLoading: true,
			errorText: '',
		}, () => {
			utils.sendRequest('/entity/getMyEntities', {})
				.then((responseData) => {
					const entities = (responseData.entities || []).map((item) => ({
						userEntityId: Number(item.userEntityId),
						name: item.name || 'Untitled Entity',
					}));

					const queryEntityID = this.getQueryUserEntityID();
					const hasQueryEntity = entities.some((item) => item.userEntityId === queryEntityID);
					const selectedUserEntityID = hasQueryEntity
						? String(queryEntityID)
						: (entities[0] ? String(entities[0].userEntityId) : '');

					this.setState({
						entities,
						selectedUserEntityID,
						isEntityLoading: false,
					});
				})
				.catch((error) => {
					this.setState({
						isEntityLoading: false,
						errorText: error && error.message ? error.message : 'Could not load your entities right now.',
					});
				});
		});
	};

	onInputChange = (event) => {
		this.setState({
			liveResumeText: event.target.value,
			errorText: '',
		});
	};

	onEntityChange = (event) => {
		this.setState({
			selectedUserEntityID: event.target.value,
			errorText: '',
		});
	};

	handleTextKeyDown = (event) => {
		if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
			this.saveLiveResume();
		}
	};

	triggerSavedConfetti = () => {
		confetti({ particleCount: 150, spread: 70, origin: { y: 0.6 } });
	};

	clearAllVerificationTimers = () => {
		if (this.processingMessageTimer) {
			window.clearInterval(this.processingMessageTimer);
			this.processingMessageTimer = null;
		}

		if (this.processingAdvanceTimer) {
			window.clearTimeout(this.processingAdvanceTimer);
			this.processingAdvanceTimer = null;
		}

		if (this.questionTimer) {
			window.clearInterval(this.questionTimer);
			this.questionTimer = null;
		}

		if (this.answerAdvanceTimer) {
			window.clearTimeout(this.answerAdvanceTimer);
			this.answerAdvanceTimer = null;
		}

		if (this.videoTimer) {
			window.clearInterval(this.videoTimer);
			this.videoTimer = null;
		}
	};

	stopVideoStream = () => {
		if (this.videoStream) {
			this.videoStream.getTracks().forEach((track) => track.stop());
			this.videoStream = null;
		}

		if (this.videoPreviewRef.current) {
			this.videoPreviewRef.current.srcObject = null;
		}
	};

	teardownVideoVerification = () => {
		if (this.videoRecorder && this.videoRecorder.state === 'recording') {
			this.videoRecorder.stop();
		}

		this.videoRecorder = null;
		this.videoChunks = [];
		this.clearAllVerificationTimers();
		this.stopVideoStream();

		if (this.state.recordedVideoURL) {
			URL.revokeObjectURL(this.state.recordedVideoURL);
		}
	};

	getPreferredVideoMimeType = () => {
		if (typeof window === 'undefined' || typeof window.MediaRecorder === 'undefined') {
			return '';
		}

		const preferred = [
			'video/mp4;codecs=h264,aac',
			'video/mp4',
			'video/webm;codecs=vp9,opus',
			'video/webm;codecs=vp8,opus',
			'video/webm',
		];

		return preferred.find((mimeType) => window.MediaRecorder.isTypeSupported(mimeType)) || '';
	};

	initVideoVerificationCamera = async () => {
		if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || typeof window.MediaRecorder === 'undefined') {
			this.setState({
				videoPermissionState: 'unsupported',
				errorText: 'This browser does not support camera recording for video verification.',
			});
			return;
		}

		this.stopVideoStream();

		try {
			const stream = await navigator.mediaDevices.getUserMedia({
				video: {
					facingMode: 'user',
					width: { ideal: 720 },
					height: { ideal: 1280 },
					aspectRatio: 9 / 16,
				},
				audio: true,
			});

			this.videoStream = stream;
			if (this.videoPreviewRef.current) {
				this.videoPreviewRef.current.srcObject = stream;
				this.videoPreviewRef.current.play().catch(() => null);
			}

			this.setState({
				videoPermissionState: 'granted',
				errorText: '',
				verificationErrorText: '',
			});
		} catch (error) {
			this.setState({
				videoPermissionState: 'denied',
				errorText: error && error.message ? error.message : 'Could not access camera or microphone.',
			});
		}
	};

	openVideoVerificationScreen = () => {
		this.clearAllVerificationTimers();
		this.setState({
			currentScreen: this.screens.VideoVerification,
			verificationMethod: 'video',
			isLoading: false,
			errorText: '',
			verificationErrorText: '',
			videoPermissionState: 'idle',
			isVideoRecording: false,
			videoSecondsLeft: MAX_VIDEO_SECONDS,
			recordedVideoBlob: null,
			recordedVideoMimeType: '',
			videoSuccessText: '',
		}, () => {
			if (this.state.recordedVideoURL) {
				URL.revokeObjectURL(this.state.recordedVideoURL);
			}

			this.setState({
				recordedVideoURL: '',
			}, this.initVideoVerificationCamera);
		});
	};

	startVideoRecording = () => {
		if (this.state.isVideoRecording) {
			return;
		}

		if (!this.videoStream || this.state.videoPermissionState !== 'granted') {
			this.setState({
				verificationErrorText: 'Camera is not ready yet. Please allow camera access first.',
			});
			return;
		}

		const mimeType = this.getPreferredVideoMimeType();
		let recorder = null;

		try {
			recorder = mimeType ? new window.MediaRecorder(this.videoStream, { mimeType }) : new window.MediaRecorder(this.videoStream);
		} catch (error) {
			this.setState({
				verificationErrorText: 'Unable to start recording on this browser.',
			});
			return;
		}

		if (this.state.recordedVideoURL) {
			URL.revokeObjectURL(this.state.recordedVideoURL);
		}

		this.videoChunks = [];
		this.videoRecorder = recorder;

		recorder.ondataavailable = (event) => {
			if (event.data && event.data.size > 0) {
				this.videoChunks.push(event.data);
			}
		};

		recorder.onstop = () => {
			const effectiveMimeType = mimeType || 'video/mp4';
			const blob = new Blob(this.videoChunks, { type: effectiveMimeType });
			const nextUrl = URL.createObjectURL(blob);

			this.setState({
				isVideoRecording: false,
				videoSecondsLeft: MAX_VIDEO_SECONDS,
				recordedVideoBlob: blob,
				recordedVideoURL: nextUrl,
				recordedVideoMimeType: effectiveMimeType,
				verificationErrorText: '',
			});
		};

		recorder.onerror = () => {
			this.setState({
				isVideoRecording: false,
				verificationErrorText: 'Recording failed. Please try again.',
			});
		};

		recorder.start();

		const recordingMimeType = mimeType || 'video/mp4';

		this.setState({
			isVideoRecording: true,
			videoSecondsLeft: MAX_VIDEO_SECONDS,
			recordedVideoBlob: null,
			recordedVideoURL: '',
			recordedVideoMimeType: recordingMimeType,
			verificationErrorText: '',
		});

		this.videoTimer = window.setInterval(() => {
			this.setState((prevState) => {
				if (!prevState.isVideoRecording) {
					return null;
				}

				if (prevState.videoSecondsLeft <= 1) {
					this.stopVideoRecording();
					return {
						videoSecondsLeft: 0,
					};
				}

				return {
					videoSecondsLeft: prevState.videoSecondsLeft - 1,
				};
			});
		}, 1000);
	};

	stopVideoRecording = () => {
		if (this.videoTimer) {
			window.clearInterval(this.videoTimer);
			this.videoTimer = null;
		}

		if (this.videoRecorder && this.videoRecorder.state === 'recording') {
			this.videoRecorder.stop();
		}
	};

	verifyWithVideo = async () => {
		if (!this.state.recordedVideoBlob) {
			this.setState({
				verificationErrorText: 'Please record a short video before verifying.',
			});
			return;
		}

		const liveResumeID = Number(this.state.currentLiveResumeID);
		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
			this.setState({
				verificationErrorText: 'No live resume item is loaded. Please save again.',
			});
			return;
		}

		this.setState({
			isLoading: true,
			errorText: '',
			verificationErrorText: '',
			videoSuccessText: '',
		});

		try {
			const uploadData = await utils.sendRequest('/liveResume/getLiveResumeVideoVerificationUploadData', {});
			const {
				uuidKey,
				originalMediaSignedUrl,
			} = uploadData || {};

			if (!uuidKey || !originalMediaSignedUrl) {
				throw new Error('Could not prepare video upload data.');
			}

			await utils.uploadFileToSignedUrl(originalMediaSignedUrl, this.state.recordedVideoBlob, {
				contentType: this.state.recordedVideoMimeType || 'video/mp4',
			});

			await utils.sendRequest('/liveResume/saveLiveResumeVideoVerification', {
				liveResumeID,
				uuidKey,
			});

			this.stopVideoRecording();
			this.stopVideoStream();

			this.setState({
				isLoading: false,
				currentScreen: this.screens.Success,
				verificationMethod: 'video',
				videoSuccessText: 'Video verification submitted.',
			});
		} catch (error) {
			this.setState({
				isLoading: false,
				errorText: error && error.message ? error.message : 'Could not submit your verification video right now.',
				verificationErrorText: error && error.message ? error.message : 'Could not submit your verification video right now.',
			});
		}
	};

	setVerificationQuestionTimer = () => {
		if (this.questionTimer) {
			window.clearInterval(this.questionTimer);
		}

		this.questionTimer = window.setInterval(() => {
			this.setState((prevState) => {
				if (prevState.currentScreen !== this.screens.Verification) {
					return null;
				}

				if (prevState.questionTimeLeft <= 1) {
					window.clearInterval(this.questionTimer);
					this.questionTimer = null;
					this.failVerification('Verification expired because the question timer reached zero.');
					return null;
				}

				return {
					questionTimeLeft: prevState.questionTimeLeft - 1,
				};
			});
		}, 1000);
	};

	startProcessingFlow = () => {
		this.clearAllVerificationTimers();

		this.setState({
			currentScreen: this.screens.Processing,
			errorText: '',
			verificationErrorText: '',
			gainedStructure: null,
			isStructureLoading: false,
			structureLoadError: '',
			processingMessageIndex: 0,
		}, () => {
			this.processingMessageTimer = window.setInterval(() => {
				this.setState((prevState) => ({
					processingMessageIndex: (prevState.processingMessageIndex + 1) % PROCESSING_STEPS.length,
				}));
			}, 1050);
		});
	};

	startVerificationFlow = () => {
		this.clearAllVerificationTimers();

		if (!this.state.verificationQuestions.length) {
			this.setState({
				currentScreen: this.screens.VerificationChoice,
				errorText: 'Verification questions are not ready yet. Please save again to generate quiz questions.',
				verificationErrorText: '',
				isLoading: false,
			});
			return;
		}

		this.setState({
			currentScreen: this.screens.Verification,
			isLoading: false,
			errorText: '',
			verificationErrorText: '',
			currentQuestionIndex: 0,
			selectedAnswerIndexes: this.state.selectedAnswersByQuestionID[this.state.verificationQuestions[0].questionID] || [],
			questionTimeLeft: 60,
		}, () => {
			this.setVerificationQuestionTimer();
		});
	};

	getAndProcessQuizQuestions = async () => {
		const liveResumeID = Number(this.state.currentLiveResumeID);

		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
			this.setState({
				currentScreen: this.screens.VerificationChoice,
				isLoading: false,
				errorText: 'No live resume item is loaded. Please save again.',
				verificationErrorText: '',
			});
			return;
		}

		this.setState({
			isLoading: true,
			errorText: '',
			verificationErrorText: '',
		});

		try {
			const response = await utils.sendRequest('/liveResume/getAndProcessLiveResumeQuestions', {
				liveResumeID,
			});

			const questionRows = Array.isArray(response && response.questions)
				? response.questions
				: (Array.isArray(response && response.choiceQuestions) ? response.choiceQuestions : []);

			if (!questionRows.length) {
				throw new Error('Could not generate verification questions right now. Please try again.');
			}

			this.setVerificationQuestions({
				liveResumeID,
				questionRows,
			});

			this.setState({
				isLoading: false,
			}, this.startVerificationFlow);
		} catch (error) {
			this.clearAllVerificationTimers();
			this.setState({
				currentScreen: this.screens.VerificationChoice,
				isLoading: false,
				errorText: error && error.message ? error.message : 'Could not generate verification questions right now.',
				verificationErrorText: '',
			});
		}
	};

	startQuizVerification = () => {
		this.teardownVideoVerification();

		if (!this.state.currentLiveResumeID) {
			this.setState({
				errorText: 'No live resume item is loaded. Please save again.',
				verificationErrorText: '',
			});
			return;
		}

		this.setState({
			verificationMethod: 'quiz',
		});

		this.startProcessingFlow();
		this.getAndProcessQuizQuestions();
	};

	openVouchScreen = () => {
		this.teardownVideoVerification();

		this.clearAllVerificationTimers();
		this.setState({
			currentScreen: this.screens.VouchFriends,
			verificationMethod: 'vouch',
			errorText: '',
			verificationErrorText: '',
			vouchSuccessText: '',
		}, this.loadPeopleForVouch);
	};

	loadPeopleForVouch = async () => {
		this.setState({
			isPeopleLoading: true,
			errorText: '',
			verificationErrorText: '',
		});

		try {
			const responseData = await utils.sendRequest('/userConnection/getPeopleForLiveResumeVerification', {});
			const people = Array.isArray(responseData && responseData.people)
				? responseData.people.map((person) => ({
					userId: Number(person.userId),
					firstName: person.firstName || '',
					lastName: person.lastName || '',
				})).filter((person) => Number.isInteger(person.userId) && person.userId > 0)
				: [];

			this.setState({
				peopleForVouch: people,
				isPeopleLoading: false,
			});
		} catch (error) {
			this.setState({
				isPeopleLoading: false,
				errorText: error && error.message ? error.message : 'Could not load people for vouching right now.',
			});
		}
	};

	toggleVouchPerson = (userId) => {
		const personID = Number(userId);
		if (!Number.isInteger(personID) || personID <= 0) {
			return;
		}

		const selectedSet = new Set(this.state.selectedVouchUserIDs || []);
		const alreadySelected = selectedSet.has(personID);
		const inviteCount = this.getCleanVouchInviteEmails().length;

		if (!alreadySelected && selectedSet.size + inviteCount >= MAX_VOUCHERS) {
			this.setState({
				verificationErrorText: `You can only select or invite up to ${MAX_VOUCHERS} people total.`,
				errorText: '',
			});
			return;
		}

		if (alreadySelected) {
			selectedSet.delete(personID);
		} else {
			selectedSet.add(personID);
		}

		this.setState({
			selectedVouchUserIDs: Array.from(selectedSet),
			verificationErrorText: '',
			errorText: '',
			vouchSuccessText: '',
		});
	};

	onVouchInviteEmailChange = (index, value) => {
		const safeIndex = Number(index);
		if (!Number.isInteger(safeIndex) || safeIndex < 0 || safeIndex > 1) {
			return;
		}

		const nextInviteEmails = [...(this.state.vouchInviteEmails || ['', ''])];
		nextInviteEmails[safeIndex] = value;

		const nextCleanEmails = Array.from(new Set(
			nextInviteEmails
				.map((item) => String(item || '').trim().toLowerCase())
				.filter((item) => item !== '')
		));

		const selectedCount = (this.state.selectedVouchUserIDs || []).length;
		if (selectedCount + nextCleanEmails.length > MAX_VOUCHERS) {
			this.setState({
				verificationErrorText: `You can only select or invite up to ${MAX_VOUCHERS} people total.`,
				errorText: '',
			});
			return;
		}

		this.setState({
			vouchInviteEmails: nextInviteEmails,
			verificationErrorText: '',
			errorText: '',
			vouchSuccessText: '',
		});
	};

	submitVouchVerification = async () => {
		const liveResumeID = Number(this.state.currentLiveResumeID);
		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
			this.setState({
				verificationErrorText: 'No live resume item is loaded. Please save again.',
			});
			return;
		}

		const selectedPeople = this.getSelectedVouchPeople();
		const inviteEmails = this.getCleanVouchInviteEmails();
		const totalVouchers = selectedPeople.length + inviteEmails.length;

		if (totalVouchers !== MAX_VOUCHERS) {
			this.setState({
				verificationErrorText: `Please choose/invite exactly ${MAX_VOUCHERS} people before continuing.`,
			});
			return;
		}

		this.setState({
			isLoading: true,
			errorText: '',
			verificationErrorText: '',
			vouchSuccessText: '',
		});

		try {
			await utils.sendRequest('/liveResume/vouchLiveResume', {
				liveResumeID,
				selectedPeople,
				inviteEmails,
			});

			this.setState({
				isLoading: false,
				currentScreen: this.screens.Success,
				verificationMethod: 'vouch',
				vouchSuccessText: 'Vouch requests sent to 2 people.',
			});
		} catch (error) {
			this.setState({
				isLoading: false,
				verificationErrorText: error && error.message ? error.message : 'Could not send vouch requests right now.',
				errorText: error && error.message ? error.message : 'Could not send vouch requests right now.',
			});
		}
	};

	goToNextVerificationQuestion = () => {
		const currentQuestion = this.state.verificationQuestions[this.state.currentQuestionIndex];
		if (!currentQuestion) {
			this.failVerification('Could not load the current verification question.');
			return;
		}

		if (!Array.isArray(this.state.selectedAnswerIndexes) || this.state.selectedAnswerIndexes.length === 0) {
			this.setState({
				verificationErrorText: 'Select an answer before continuing.',
			});
			return;
		}

		const totalQuestions = this.state.verificationQuestions.length;
		const nextQuestionIndex = this.state.currentQuestionIndex + 1;
		const isFinalQuestion = nextQuestionIndex >= totalQuestions;

		this.clearAllVerificationTimers();

		if (isFinalQuestion) {
			this.verifySelectedAnswers();
			return;
		}

		const nextQuestion = this.state.verificationQuestions[nextQuestionIndex];

		this.setState({
			currentQuestionIndex: nextQuestionIndex,
			selectedAnswerIndexes: nextQuestion ? (this.state.selectedAnswersByQuestionID[nextQuestion.questionID] || []) : [],
			questionTimeLeft: 60,
			verificationErrorText: '',
		}, () => {
			this.setVerificationQuestionTimer();
		});
	};

	verifySelectedAnswers = async () => {
		const liveResumeID = Number(this.state.currentLiveResumeID);

		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
			this.failVerification('No live resume is loaded for answer verification. Please save again.');
			return;
		}

		this.setState({
			isLoading: true,
			verificationErrorText: '',
		});

		try {
			const answersResponse = await utils.sendRequest('/liveResume/getLiveResumeAnswers', {
				liveResumeID,
			});

			const answerRows = answersResponse && Array.isArray(answersResponse.answers)
				? answersResponse.answers
				: [];

			const verificationAnswersByQuestionID = {};
			const answerExplanationByQuestionID = {};
			answerRows.forEach((row) => {
				const questionID = Number(row.userEntityLiveResumeChoiceQuestionId);
				verificationAnswersByQuestionID[questionID] = this.answerLettersToIndexes(row.answers);
				answerExplanationByQuestionID[questionID] = row.answerExplanation || '';
			});

			const verificationMisses = [];
			this.state.verificationQuestions.forEach((question) => {
				const selectedAnswerIndexes = this.state.selectedAnswersByQuestionID[question.questionID] || [];
				const correctAnswerIndexes = verificationAnswersByQuestionID[question.questionID] || [];

				if (!this.areAnswerSetsEqual(selectedAnswerIndexes, correctAnswerIndexes)) {
					verificationMisses.push({
						questionID: question.questionID,
						question: question.question,
						options: question.options,
						selectedAnswerIndexes,
						correctAnswerIndexes,
						answerExplanation: answerExplanationByQuestionID[question.questionID] || '',
					});
				}
			});

			if (verificationMisses.length > 0) {
				this.setState({
					isLoading: false,
					currentScreen: this.screens.Failure,
					verificationAnswersByQuestionID,
					verificationMisses,
					errorText: `${verificationMisses.length} answer${verificationMisses.length > 1 ? 's were' : ' was'} missed.`,
					verificationErrorText: `${verificationMisses.length} answer${verificationMisses.length > 1 ? 's were' : ' was'} missed.`,
					selectedAnswerIndexes: [],
					questionTimeLeft: 0,
				});
				return;
			}

			this.setState({
				isLoading: false,
				verificationAnswersByQuestionID,
				verificationMisses: [],
				currentScreen: this.screens.Success,
				verificationErrorText: '',
				selectedAnswerIndexes: [],
				questionTimeLeft: 60,
			}, () => {
				this.triggerSavedConfetti();
				this.loadLiveResumeStructure();
			});
		} catch (error) {
			this.setState({
				isLoading: false,
				verificationErrorText: error && error.message ? error.message : 'Could not verify answers right now.',
				errorText: error && error.message ? error.message : 'Could not verify answers right now.',
				currentScreen: this.screens.Failure,
			});
		}
	};

	loadLiveResumeStructure = async () => {
		const liveResumeID = Number(this.state.currentLiveResumeID);

		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
			this.setState({
				currentScreen: this.screens.StructureSummary,
				isStructureLoading: false,
				gainedStructure: null,
				structureLoadError: 'No live resume was found for structure loading. Please save again.',
			});
			return;
		}

		this.setState({
			isStructureLoading: true,
			structureLoadError: '',
			errorText: '',
		});

		try {
			const response = await utils.sendRequest('/liveResume/getLiveResumeStructure', {
				userEntityLiveResumeID: liveResumeID,
			});

			if (!response || response.status !== 'ready' || !response.structure) {
				this.setState({
					currentScreen: this.screens.StructureSummary,
					isStructureLoading: false,
					gainedStructure: null,
					structureLoadError: 'Structure is still being generated. Please retry in a few seconds.',
				});
				return;
			}

			this.setState({
				currentScreen: this.screens.StructureSummary,
				isStructureLoading: false,
				gainedStructure: response.structure,
				structureLoadError: '',
			});
		} catch (error) {
			this.setState({
				currentScreen: this.screens.StructureSummary,
				isStructureLoading: false,
				gainedStructure: null,
				structureLoadError: error && error.message ? error.message : 'Could not load generated structure right now.',
			});
		}
	};

	failVerification = (message) => {
		this.clearAllVerificationTimers();

		this.setState({
			currentScreen: this.screens.Failure,
			errorText: message,
			verificationErrorText: message,
			selectedAnswerIndexes: [],
			questionTimeLeft: 0,
		});
	};

	restartVerification = () => {
		if (!this.state.currentLiveResumeID || !this.state.verificationQuestions.length) {
			this.failVerification('No live resume is loaded for verification. Please save again.');
			return;
		}

		this.setState({
			errorText: '',
			verificationErrorText: '',
			verificationAnswersByQuestionID: {},
			selectedAnswersByQuestionID: {},
			learningIntentQuestionIDs: [],
			verificationMisses: [],
		}, this.startVerificationFlow);
	};

	saveLiveResume = () => {
		const liveResumeText = this.state.liveResumeText.trim();

		if (liveResumeText === '') {
			this.setState({
				errorText: 'Please enter a live resume update before saving.',
			});
			return;
		}

		const userEntityID = Number(this.state.selectedUserEntityID);
		if (!Number.isInteger(userEntityID) || userEntityID <= 0) {
			this.setState({
				errorText: 'Please select a user entity first.',
			});
			return;
		}

		this.setState({
			isLoading: true,
			errorText: '',
			verificationErrorText: '',
			vouchSuccessText: '',
		}, async () => {
			try {
				const saveResponse = await utils.sendRequest('/liveResume/saveLiveResume', {
					userEntityID,
					liveResumeText,
				});

				const liveResumeID = Number(saveResponse && saveResponse.userEntityLiveResumeID);
				if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
					throw new Error('Save succeeded but no liveResumeID was returned.');
				}

				this.setState({
					currentScreen: this.screens.VerificationChoice,
					verificationQuestions: [],
					verificationAnswersByQuestionID: {},
					selectedAnswersByQuestionID: {},
					learningIntentQuestionIDs: [],
					verificationMisses: [],
					currentLiveResumeID: liveResumeID,
					verificationMethod: '',
					peopleForVouch: [],
					selectedVouchUserIDs: [],
					vouchInviteEmails: ['', ''],
					vouchSuccessText: '',
					isLoading: false,
				});
			}
			catch (error) {
				this.setState({
					currentScreen: this.screens.Composer,
					isLoading: false,
					errorText: error && error.message ? error.message : 'Could not save live resume right now. Please try again.',
				});
			}
		});
	};

	handleAnswerSelect = (answerIndex) => {
		const {
			currentScreen,
			currentQuestionIndex,
			verificationQuestions,
			selectedAnswerIndexes,
		} = this.state;

		if (currentScreen !== this.screens.Verification) {
			return;
		}

		const currentQuestion = verificationQuestions[currentQuestionIndex];
		if (!currentQuestion) {
			this.failVerification('Could not load the current verification question.');
			return;
		}

		const questionID = currentQuestion.questionID;
		const currentSelectedAnswerIndexes = Array.isArray(selectedAnswerIndexes) ? selectedAnswerIndexes : [];
		const nextSelectedAnswerIndexes = currentSelectedAnswerIndexes.includes(answerIndex)
			? currentSelectedAnswerIndexes.filter((item) => item !== answerIndex)
			: [...currentSelectedAnswerIndexes, answerIndex].sort((a, b) => a - b);

		const nextLearningIntentQuestionIDs = nextSelectedAnswerIndexes.includes(4)
			? Array.from(new Set([...this.state.learningIntentQuestionIDs, questionID]))
			: this.state.learningIntentQuestionIDs.filter((item) => item !== questionID);

		this.setState({
			selectedAnswerIndexes: nextSelectedAnswerIndexes,
			selectedAnswersByQuestionID: {
				...this.state.selectedAnswersByQuestionID,
				[questionID]: nextSelectedAnswerIndexes,
			},
			learningIntentQuestionIDs: nextLearningIntentQuestionIDs,
			verificationErrorText: '',
		});
	};

	goToDashboard = () => {
		window.location.href = '/dashboard';
	};

	goBackToComposer = () => {
		this.teardownVideoVerification();

		this.clearAllVerificationTimers();
		this.setState({
			currentScreen: this.screens.Composer,
			isLoading: false,
			errorText: '',
			verificationErrorText: '',
			verificationQuestions: [],
			verificationAnswersByQuestionID: {},
			selectedAnswersByQuestionID: {},
			learningIntentQuestionIDs: [],
			verificationMisses: [],
			currentLiveResumeID: 0,
			verificationMethod: '',
			gainedStructure: null,
			isStructureLoading: false,
			structureLoadError: '',
			peopleForVouch: [],
			selectedVouchUserIDs: [],
			vouchInviteEmails: ['', ''],
			isPeopleLoading: false,
			vouchSuccessText: '',
			videoPermissionState: 'idle',
			isVideoRecording: false,
			videoSecondsLeft: MAX_VIDEO_SECONDS,
			recordedVideoBlob: null,
			recordedVideoURL: '',
			recordedVideoMimeType: '',
			videoSuccessText: '',
			processingMessageIndex: 0,
			currentQuestionIndex: 0,
			selectedAnswerIndexes: [],
			questionTimeLeft: 60,
		});
	};

	goBackToVerificationChoice = () => {
		if (this.state.recordedVideoURL) {
			URL.revokeObjectURL(this.state.recordedVideoURL);
		}

		this.stopVideoRecording();
		this.stopVideoStream();

		this.clearAllVerificationTimers();
		this.setState({
			currentScreen: this.screens.VerificationChoice,
			isLoading: false,
			errorText: '',
			verificationErrorText: '',
			vouchSuccessText: '',
			isVideoRecording: false,
			videoSecondsLeft: MAX_VIDEO_SECONDS,
			videoPermissionState: 'idle',
			recordedVideoBlob: null,
			recordedVideoURL: '',
			recordedVideoMimeType: '',
		});
	};

	getStepIndex = (screen) => {
		const activeScreen = screen || this.state.currentScreen;
		const verificationScreens = new Set([
			this.screens.VerificationChoice,
			this.screens.VouchFriends,
			this.screens.VideoVerification,
			this.screens.Processing,
			this.screens.Verification,
		]);

		if (verificationScreens.has(activeScreen)) {
			return 1;
		}

		const completionScreens = new Set([
			this.screens.Failure,
			this.screens.Success,
			this.screens.StructureSummary,
		]);

		if (completionScreens.has(activeScreen)) {
			return 2;
		}

		return 0;
	};

	renderDot = (screen) => {
		const stepIndex = this.getStepIndex(screen);

		return (
			<div className={styles.stepRow}>
				<div className={`${styles.stepDot} ${stepIndex >= 0 ? styles.stepDotActive : ''}`} />
				<div className={styles.stepLine} />
				<div className={`${styles.stepDot} ${stepIndex >= 1 ? styles.stepDotActive : ''}`} />
				<div className={styles.stepLine} />
				<div className={`${styles.stepDot} ${stepIndex >= 2 ? styles.stepDotActive : ''}`} />
			</div>
		);
	};

	renderScreenLayout = ({
		screen,
		title,
		subtitle,
		caption,
		formTitle,
		formText,
		errorText,
		children,
	}) => {
		return (
			<>
				<section className={styles.headerPanel}>
					<h1 className={styles.title}>{title}</h1>
					<p className={styles.subtitle}>{subtitle}</p>

					<div className={styles.userRow}>
						<span className={styles.userCaption}>{caption}</span>
					</div>
				</section>

				<section className={styles.mainCardPanel}>
					{this.renderDot(screen)}
					<h2 className={styles.formTitle}>{formTitle}</h2>
					<p className={styles.formText}>{formText}</p>

					{children}

					{errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
				</section>
			</>
		);
	};

	renderComposerScreen = () => {
		const {
			entities,
			selectedUserEntityID,
			isEntityLoading,
			liveResumeText,
			isLoading,
			errorText,
		} = this.state;

		return (
			this.renderScreenLayout({
				screen: this.screens.Composer,
				title: 'Capture your latest contribution while it is fresh.',
				subtitle: 'Write a concise update on what you just accomplished.',
				caption: 'Focus on impact, outcomes, and ownership.',
				formTitle: 'Live Resume Check-In',
				formText: "Write a concise update on what you've just accomplished: impact, outcomes, and ownership.",
				errorText,
				children: (
					<div className={styles.form}>
						<div className={styles.fieldGroup}>
							<label className={styles.label} htmlFor='user-entity'>Live Resume For</label>
							<div className={styles.selectWrap}>
								<select
									id='user-entity'
									name='userEntity'
									className={styles.selectInput}
									value={selectedUserEntityID}
									onChange={this.onEntityChange}
									disabled={isEntityLoading || isLoading}
								>
									<option value=''>
										{isEntityLoading ? 'Loading entities...' : 'Choose an entity'}
									</option>
									{entities.map((entity) => {
										return (
											<option key={`entity-${entity.userEntityId}`} value={String(entity.userEntityId)}>
												{entity.name}
											</option>
										);
									})}
								</select>
							</div>
						</div>

						<div className={styles.fieldGroup}>
							<label className={styles.label} htmlFor='live-resume-text'>Live Resume Update</label>
							<textarea
								id='live-resume-text'
								name='liveResumeText'
								className={styles.textArea}
								placeholder='Example: Led migration to typed APIs across 4 services, reduced production incidents by 35%, and mentored two engineers through rollout.'
								value={liveResumeText}
								onChange={this.onInputChange}
								onKeyDown={this.handleTextKeyDown}
							/>
						</div>

						<button className={styles.primaryButton} onClick={this.saveLiveResume} disabled={isLoading}>
							{isLoading ? 'Saving...' : 'Save Live Resume'}
						</button>

						<p className={styles.hintText}>Tip: Press Ctrl/Cmd + Enter to save quickly.</p>
					</div>
				),
			})
		);
	};

	renderProcessingScreen = () => {
		const {
			processingMessageIndex,
			errorText,
		} = this.state;

		return (
			this.renderScreenLayout({
				screen: this.screens.Processing,
				title: 'Capture your latest contribution while it is fresh.',
				subtitle: 'Write a concise update on what you just accomplished.',
				caption: 'Focus on impact, outcomes, and ownership.',
				formTitle: 'Preparing Verification',
				formText: 'Saving your live resume update and preparing anti-cheat verification.',
				errorText,
				children: (
					<div className={styles.processingWrap}>
						<div className={styles.processingOrb} />
						<div className={styles.processingCopy}>
							<div className={styles.processingLabel}>Processing saved update</div>
							<h3 className={styles.processingTitle}>Preparing your verification flow</h3>
							<p className={styles.processingText}>We are turning your live resume into a focused, anti-cheat verification sequence.</p>
						</div>

						<div className={styles.processingStatusCard}>
							{PROCESSING_STEPS.map((step, index) => {
								const isActive = index === processingMessageIndex;

								return (
									<div key={step} className={`${styles.processingStep} ${isActive ? styles.processingStepActive : ''}`}>
										<span className={styles.processingDot} />
										<span>{step}</span>
									</div>
								);
							})}
						</div>
					</div>
				),
			})
		);
	};

	renderVerificationChoiceScreen = () => {
		const { isLoading, errorText } = this.state;

		return (
			this.renderScreenLayout({
				screen: this.screens.VerificationChoice,
				title: 'Capture your latest contribution while it is fresh.',
				subtitle: 'Pick the strongest verification path for this update.',
				caption: 'Choose the option that is fastest and most accurate for you.',
				formTitle: 'Choose Verification Method',
				formText: 'Verify now using a quiz, a short video, or human vouching.',
				errorText,
				children: (
					<div className={styles.methodChoiceWrap}>
						<div className={styles.methodChoiceCard}>
							<h3 className={styles.methodChoiceTitle}>Verify now with a 3 question quiz</h3>
							<p className={styles.methodChoiceText}>Immediate verification using generated questions from your live resume entry.</p>
							<button className={styles.primaryButton} onClick={this.startQuizVerification} disabled={isLoading}>
								Start Quiz Verification
							</button>
						</div>

						<div className={styles.methodChoiceCard}>
							<h3 className={styles.methodChoiceTitle}>Verify now by recording a short video</h3>
							<p className={styles.methodChoiceText}>Record up to 30 seconds explaining what you accomplished in your own words.</p>
							<button className={styles.primaryButton} onClick={this.openVideoVerificationScreen} disabled={isLoading}>
								Record Verification Video
							</button>
						</div>

						{/* todo */}
						{/* <div className={styles.methodChoiceCard}>
							<h3 className={styles.methodChoiceTitle}>Verify by having 2 people vouch</h3>
							<p className={styles.methodChoiceText}>Choose connections, invite by email, or combine both. Maximum total is 2 people.</p>
							<button className={styles.primaryButton} onClick={this.openVouchScreen} disabled={isLoading}>
								Have Friends Vouch
							</button>
						</div> */}
					</div>
				),
			})
		);
	};

	renderVideoVerificationScreen = () => {
		const {
			videoPermissionState,
			isVideoRecording,
			videoSecondsLeft,
			recordedVideoURL,
			isLoading,
			verificationErrorText,
			recordedVideoMimeType,
		} = this.state;

		const isMP4 = String(recordedVideoMimeType || '').toLowerCase().includes('video/mp4');
		const hasCameraFailure = videoPermissionState === 'denied' || videoPermissionState === 'unsupported';
		const showLivePreview = !hasCameraFailure;

		return (
			this.renderScreenLayout({
				screen: this.screens.VideoVerification,
				title: 'Capture your latest contribution while it is fresh.',
				subtitle: 'Verify by speaking directly to camera.',
				caption: 'A short portrait video is enough. Keep it specific and clear.',
				formTitle: 'Record Verification Video',
				formText: `Record for up to ${MAX_VIDEO_SECONDS} seconds, then submit.`,
				errorText: this.state.errorText,
				children: (
					<div className={styles.videoWrap}>
						<div className={styles.verificationBanner}>
							Record a video of yourself explaining this live-resume for up to {MAX_VIDEO_SECONDS} seconds. Camera and microphone permission is required.
						</div>

						<button className={hasCameraFailure ? styles.primaryButton : styles.secondaryButton} onClick={this.initVideoVerificationCamera} disabled={isLoading}>
							Retry Camera Access
						</button>

						<div className={styles.videoCard}>
							{showLivePreview && (
								<div className={styles.videoPreviewShell}>
									<video
										ref={this.videoPreviewRef}
										className={styles.videoPreview}
										autoPlay
										muted
										playsInline
									/>

									<div className={styles.videoTimerBadge}>Time left: {videoSecondsLeft}s</div>

									<button
										type='button'
										className={styles.videoRecordControl}
										onClick={isVideoRecording ? this.stopVideoRecording : this.startVideoRecording}
										disabled={isLoading || videoPermissionState !== 'granted'}
										aria-label={isVideoRecording ? 'Stop recording' : 'Start recording'}
									>
										{isVideoRecording
											? <span className={styles.videoStopGlyph} />
											: <span className={styles.videoRecordGlyph} />
										}
									</button>
								</div>
							)}

							{videoPermissionState === 'denied' && (
								<div className={styles.errorBox}>Camera permission was denied. Allow access and retry.</div>
							)}

							{videoPermissionState === 'unsupported' && (
								<div className={styles.errorBox}>Video recording is not supported in this browser.</div>
							)}

							{/* {recordedVideoURL !== '' && (
								<div className={styles.videoReviewWrap}>
									<div className={styles.videoReviewLabel}>Recorded clip preview</div>
									<video className={styles.videoPlayback} src={recordedVideoURL} controls playsInline />
									{!isMP4 && <div className={styles.hintText}>Current browser produced {recordedVideoMimeType || 'a non-mp4 format'}.</div>}
								</div>
							)} */}

							{verificationErrorText !== '' && <div className={styles.errorBox}>{verificationErrorText}</div>}

							<div className={styles.failureActions}>
								{!hasCameraFailure && (
									<button
										className={styles.primaryButton}
										onClick={this.verifyWithVideo}
										disabled={isLoading || isVideoRecording || !recordedVideoURL}
									>
										{isLoading ? 'Verifying...' : 'Verify'}
									</button>
								)}

								<button className={styles.secondaryButton} onClick={this.goBackToVerificationChoice} disabled={isLoading}>
									Back
								</button>
							</div>
						</div>
					</div>
				),
			})
		);
	};

	renderVouchScreen = () => {
		const {
			peopleForVouch,
			selectedVouchUserIDs,
			vouchInviteEmails,
			isPeopleLoading,
			isLoading,
			verificationErrorText,
		} = this.state;

		const selectedSet = new Set(selectedVouchUserIDs || []);
		const currentVouchCount = this.getCurrentVouchCount();

		return (
			this.renderScreenLayout({
				screen: this.screens.VouchFriends,
				title: 'Capture your latest contribution while it is fresh.',
				subtitle: 'Use social verification when peers can confirm quickly.',
				caption: 'Pick exactly two vouchers using existing people and/or email invites.',
				formTitle: 'Have Friends Vouch',
				formText: `Choose and/or invite exactly ${MAX_VOUCHERS} people to vouch for this item.`,
				errorText: this.state.errorText,
				children: (
					<div className={styles.vouchWrap}>
						<div className={styles.verificationBanner}>
							Choose and/or invite exactly {MAX_VOUCHERS} people to vouch for this live resume item.
						</div>

						<div className={styles.questionCard}>
							<h3 className={styles.questionText}>People You Can Ask</h3>
							{isPeopleLoading && <p className={styles.structureText}>Loading people...</p>}
							{!isPeopleLoading && peopleForVouch.length === 0 && <p className={styles.structureText}>No existing people available right now. You can invite by email below.</p>}

							{!isPeopleLoading && peopleForVouch.length > 0 && (
								<div className={styles.peopleList}>
									{peopleForVouch.map((person) => {
										const isSelected = selectedSet.has(person.userId);
										const disabled = !isSelected && currentVouchCount >= MAX_VOUCHERS;
										const buttonClass = [styles.personButton, isSelected ? styles.personButtonSelected : ''].filter(Boolean).join(' ');

										return (
											<button
												key={`person-${person.userId}`}
												className={buttonClass}
												onClick={() => this.toggleVouchPerson(person.userId)}
												disabled={isLoading || disabled}
											>
												<span>{`${person.firstName} ${person.lastName}`.trim() || `User ${person.userId}`}</span>
												{isSelected && <span className={styles.reviewSelectedTag}>Selected</span>}
											</button>
										);
									})}
								</div>
							)}

							<h3 className={styles.questionText}>Invite People By Email</h3>
							<div className={styles.vouchInviteGrid}>
								<input
									type='text'
									className={styles.selectInput}
									placeholder='person1@example.com'
									value={vouchInviteEmails[0] || ''}
									onChange={(event) => this.onVouchInviteEmailChange(0, event.target.value)}
									disabled={isLoading}
								/>
								<input
									type='text'
									className={styles.selectInput}
									placeholder='person2@example.com'
									value={vouchInviteEmails[1] || ''}
									onChange={(event) => this.onVouchInviteEmailChange(1, event.target.value)}
									disabled={isLoading}
								/>
							</div>

							<div className={styles.vouchMetaRow}>
								<div className={styles.verificationPill}>Selected total: {currentVouchCount} / {MAX_VOUCHERS}</div>
							</div>

							{verificationErrorText !== '' && <div className={styles.errorBox}>{verificationErrorText}</div>}

							<div className={styles.failureActions}>
								<button className={styles.primaryButton} onClick={this.submitVouchVerification} disabled={isLoading}>
									{isLoading ? 'Sending...' : 'Send Vouch Requests'}
								</button>
								<button className={styles.secondaryButton} onClick={this.goBackToVerificationChoice} disabled={isLoading}>
									Back
								</button>
							</div>
						</div>
					</div>
				),
			})
		);
	};

	renderVerificationScreen = () => {
		const {
			currentQuestionIndex,
			selectedAnswerIndexes,
			questionTimeLeft,
			verificationQuestions,
			isLoading,
		} = this.state;

		const currentQuestion = verificationQuestions[currentQuestionIndex];
		const totalQuestions = verificationQuestions.length;

		if (!currentQuestion) {
			return this.renderScreenLayout({
				screen: this.screens.Verification,
				title: 'Capture your latest contribution while it is fresh.',
				subtitle: 'Answer the generated verification questions.',
				caption: 'Work quickly and accurately. Timer is active per question.',
				formTitle: 'Verification Question',
				formText: 'Loading verification questions...',
				errorText: this.state.errorText,
				children: (
					<div className={styles.verificationWrap}>
						<div className={styles.verificationBanner}>Loading verification questions...</div>
					</div>
				),
			});
		}

		return (
			this.renderScreenLayout({
				screen: this.screens.Verification,
				title: 'Capture your latest contribution while it is fresh.',
				subtitle: 'Answer the generated verification questions.',
				caption: 'Work quickly and accurately. Timer is active per question.',
				formTitle: `Verification Question ${currentQuestionIndex + 1}`,
				formText: 'Choose the best option and press Next. Option E marks a learning intent.',
				errorText: this.state.errorText,
				children: (
					<div className={styles.verificationWrap}>
						<div className={styles.verificationTopRow}>
							<div className={styles.verificationPill}>Question {currentQuestionIndex + 1} of {totalQuestions}</div>
							<div className={styles.verificationPill}>{questionTimeLeft}s remaining</div>
						</div>

						<div className={styles.verificationBanner}>
							Choose the best option and press Next. Option E marks that you want to learn this topic.
						</div>

						<div className={styles.questionCard}>
							<h3 className={styles.questionText}>{currentQuestion.question}</h3>

							<div className={styles.optionsList}>
								{[...currentQuestion.options, "I don't know the answer, but I want to learn about this"].map((option, optionIndex) => {
									const isSelected = Array.isArray(selectedAnswerIndexes) && selectedAnswerIndexes.includes(optionIndex);
									const optionClassName = [
										styles.optionButton,
										isSelected ? styles.optionButtonSelected : '',
									].filter(Boolean).join(' ');

									return (
										<button
											key={`${currentQuestionIndex}-${optionIndex}`}
											className={optionClassName}
											onClick={() => this.handleAnswerSelect(optionIndex)}
											disabled={isLoading}
										>
											<span className={styles.optionLetter}>{String.fromCharCode(65 + optionIndex)}.</span>
											<span className={styles.optionText}>{option}</span>
										</button>
									);
								})}
							</div>

							{this.state.verificationErrorText !== '' && <div className={styles.errorBox}>{this.state.verificationErrorText}</div>}

							<button
								className={styles.primaryButton}
								onClick={this.goToNextVerificationQuestion}
								disabled={!Array.isArray(selectedAnswerIndexes) || selectedAnswerIndexes.length === 0 || isLoading}
							>
								{currentQuestionIndex + 1 === totalQuestions ? (isLoading ? 'Checking...' : 'Finish & Check Answers') : 'Next'}
							</button>
						</div>
					</div>
				),
			})
		);
	};

	renderFailureScreen = () => {
		const { verificationErrorText, verificationMisses } = this.state;
		const hasMissedAnswers = Array.isArray(verificationMisses) && verificationMisses.length > 0;

		return (
			this.renderScreenLayout({
				screen: this.screens.Failure,
				title: 'Capture your latest contribution while it is fresh.',
				subtitle: 'Verification can be retried right away.',
				caption: 'Review misses and continue with a stronger attempt.',
				formTitle: 'Verification Results',
				formText: hasMissedAnswers ? 'Some answers were missed. Review the details below.' : 'The verification session was interrupted.',
				errorText: '',
				children: (
					<div className={styles.failureWrap}>
						<div className={styles.failureBadge}>{hasMissedAnswers ? 'Verification result' : 'Verification stopped'}</div>
						<h3 className={styles.failureTitle}>{hasMissedAnswers ? 'Some answers were missed' : 'Verification interrupted'}</h3>
						<p className={styles.failureText}>{verificationErrorText || 'The verification session was interrupted.'}</p>

						{hasMissedAnswers && (
							<div className={styles.missedAnswersList}>
								{verificationMisses.map((item) => {
									const baseOptions = Array.isArray(item.options) ? item.options : [];
									const selectedAnswerIndexes = Array.isArray(item.selectedAnswerIndexes) ? item.selectedAnswerIndexes : [];
									const correctAnswerIndexes = Array.isArray(item.correctAnswerIndexes) ? item.correctAnswerIndexes : [];
									const shouldShowLearningOption = selectedAnswerIndexes.includes(4) || correctAnswerIndexes.includes(4);
									const renderedOptions = shouldShowLearningOption
										? [...baseOptions, "I don't know the answer, but I want to learn about this"]
										: baseOptions;

									return (
										<div key={`missed-${item.questionID}`} className={styles.missedAnswerCard}>
											<div className={styles.missedAnswerQuestion}>{item.question}</div>

											<div className={styles.reviewOptionsList}>
												{renderedOptions.map((optionText, optionIndex) => {
													const isSelected = selectedAnswerIndexes.includes(optionIndex);
													const isCorrect = correctAnswerIndexes.includes(optionIndex);
													const rowClass = [
														styles.reviewOptionRow,
														isCorrect ? styles.reviewOptionCorrect : '',
														isSelected && !isCorrect ? styles.reviewOptionWrong : '',
													].filter(Boolean).join(' ');

													return (
														<div key={`review-${item.questionID}-${optionIndex}`} className={rowClass}>
															<span className={styles.reviewOptionLetter}>{String.fromCharCode(65 + optionIndex)}.</span>
															<span className={styles.reviewOptionText}>{optionText}</span>
															{isSelected && <span className={styles.reviewSelectedTag}>Selected</span>}
															{isCorrect && <span className={styles.reviewCheckIcon}>Correct</span>}
														</div>
													);
												})}
											</div>

											{item.answerExplanation && <div className={styles.missedAnswerMeta}>Explanation: {item.answerExplanation}</div>}
										</div>
									);
								})}
							</div>
						)}

						<div className={styles.failureActions}>
							<button className={styles.primaryButton} onClick={this.goToDashboard}>
								Back To Dashboard
							</button>
							{/* <button className={styles.primaryButton} onClick={this.restartVerification}>
								Retry Verification
							</button>
							<button className={styles.secondaryButton} onClick={this.goBackToComposer}>
								Back To Composer
							</button> */}
						</div>
					</div>
				),
			})
		);
	};

	renderSuccessScreen = () => {
		const { verificationMethod, videoSuccessText, vouchSuccessText } = this.state;
		const methodCopy = {
			video: {
				icon: 'Video Submitted',
				title: 'Video Verification Started',
				text: videoSuccessText || 'Your short video has been captured for verification.',
			},
			vouch: {
				icon: 'Requests Sent',
				title: 'Vouch Verification Started',
				text: vouchSuccessText || 'Your vouch requests are out for this live resume item.',
			},
			quiz: {
				icon: 'Verified',
				title: 'Live Resume Verified',
				text: 'Your update passed verification. Preparing your gained structure summary...',
			},
		};
		const successCopy = methodCopy[verificationMethod] || methodCopy.quiz;

		return this.renderScreenLayout({
			screen: this.screens.Success,
			title: 'Capture your latest contribution while it is fresh.',
			subtitle: 'Verification is complete for this step.',
			caption: 'You can return to your dashboard or log another contribution.',
			formTitle: 'Verification Complete',
			formText: successCopy.text,
			errorText: '',
			children: (
				<div className={styles.successWrap}>
					<div className={styles.successIcon}>{successCopy.icon}</div>
					<h3 className={styles.successTitle}>{successCopy.title}</h3>
					<p className={styles.successText}>{successCopy.text}</p>
					<div className={styles.failureActions}>
						<button className={styles.primaryButton} onClick={this.goToDashboard}>
							Back To Dashboard
						</button>
						<button className={styles.secondaryButton} onClick={this.goBackToComposer}>
							Save Another Update
						</button>
					</div>
				</div>
			),
		});
	};

	renderStructureSummaryScreen = () => {
		const {
			isStructureLoading,
			gainedStructure,
			structureLoadError,
		} = this.state;

		if (isStructureLoading) {
			return this.renderScreenLayout({
				screen: this.screens.StructureSummary,
				title: 'Capture your latest contribution while it is fresh.',
				subtitle: 'Your verified update is being structured.',
				caption: 'This can take a moment while data is grouped and normalized.',
				formTitle: 'Generated Structure Summary',
				formText: 'Building your summary from verified data.',
				errorText: '',
				children: (
					<div className={styles.successWrap}>
						<div className={styles.successIcon}>Preparing</div>
						<h3 className={styles.successTitle}>Building your summary</h3>
						<p className={styles.successText}>We are collecting your skills, tools, domains, soft skills, impacts, and achievements.</p>
					</div>
				),
			});
		}

		if (!gainedStructure) {
			return this.renderScreenLayout({
				screen: this.screens.StructureSummary,
				title: 'Capture your latest contribution while it is fresh.',
				subtitle: 'Your verified update is being structured.',
				caption: 'Retry when generation is complete.',
				formTitle: 'Generated Structure Summary',
				formText: 'Structure is not ready yet.',
				errorText: '',
				children: (
					<div className={styles.failureWrap}>
						<div className={styles.failureBadge}>Structure pending</div>
						<h3 className={styles.failureTitle}>Not ready yet</h3>
						<p className={styles.failureText}>{structureLoadError || 'Structure generation is still in progress.'}</p>

						<div className={styles.failureActions}>
							<button className={styles.primaryButton} onClick={this.loadLiveResumeStructure}>
								Retry Loading Structure
							</button>
							<button className={styles.secondaryButton} onClick={this.goBackToComposer}>
								Back To Composer
							</button>
						</div>
					</div>
				),
			});
		}

		const skills = Array.isArray(gainedStructure.skills) ? gainedStructure.skills : [];
		const tools = Array.isArray(gainedStructure.tools) ? gainedStructure.tools : [];
		const domains = Array.isArray(gainedStructure.domains) ? gainedStructure.domains : [];
		const softSkills = Array.isArray(gainedStructure.softSkills) ? gainedStructure.softSkills : [];
		const impacts = Array.isArray(gainedStructure.impacts) ? gainedStructure.impacts : [];
		const achievements = Array.isArray(gainedStructure.achievements) ? gainedStructure.achievements : [];

		return this.renderScreenLayout({
			screen: this.screens.StructureSummary,
			title: 'Capture your latest contribution while it is fresh.',
			subtitle: 'Your verified update has been converted to structured data.',
			caption: 'Review and continue to your dashboard.',
			formTitle: 'Generated Structure Summary',
			formText: 'This summary is generated from your verified update.',
			errorText: '',
			children: (
				<div className={styles.structureWrap}>
					<div className={styles.structureCard}>
						<h3 className={styles.structureTitle}>Skills</h3>
						<p className={styles.structureText}>{skills.length ? skills.map((item) => item.name).join(', ') : 'No skills captured.'}</p>
					</div>

					<div className={styles.structureCard}>
						<h3 className={styles.structureTitle}>Tools</h3>
						<p className={styles.structureText}>{tools.length ? tools.map((item) => item.name).join(', ') : 'No tools captured.'}</p>
					</div>

					<div className={styles.structureCard}>
						<h3 className={styles.structureTitle}>Domains</h3>
						<p className={styles.structureText}>{domains.length ? domains.map((item) => item.name).join(', ') : 'No domains captured.'}</p>
					</div>

					<div className={styles.structureCard}>
						<h3 className={styles.structureTitle}>Soft Skills</h3>
						<p className={styles.structureText}>{softSkills.length ? softSkills.map((item) => item.name).join(', ') : 'No soft skills captured.'}</p>
					</div>

					<div className={styles.structureCard}>
						<h3 className={styles.structureTitle}>Impacts</h3>
						<p className={styles.structureText}>{impacts.length ? impacts.map((item) => item.impact).join(' | ') : 'No impacts captured.'}</p>
					</div>

					<div className={styles.structureCard}>
						<h3 className={styles.structureTitle}>Achievements</h3>
						<p className={styles.structureText}>{achievements.length ? achievements.map((item) => item.achievement).join(' | ') : 'No achievements captured.'}</p>
					</div>

					<button className={styles.primaryButton} onClick={this.goToDashboard}>
						Back To Dashboard
					</button>
					<button className={styles.secondaryButton} onClick={this.goBackToComposer}>
						Save Another Update
					</button>
				</div>
			),
		});
	};

	renderCurrentScreen = () => {
		const { currentScreen } = this.state;
		const renderers = {
			[this.screens.Composer]: this.renderComposerScreen,
			[this.screens.VerificationChoice]: this.renderVerificationChoiceScreen,
			[this.screens.VouchFriends]: this.renderVouchScreen,
			[this.screens.VideoVerification]: this.renderVideoVerificationScreen,
			[this.screens.Processing]: this.renderProcessingScreen,
			[this.screens.Verification]: this.renderVerificationScreen,
			[this.screens.Failure]: this.renderFailureScreen,
			[this.screens.Success]: this.renderSuccessScreen,
			[this.screens.StructureSummary]: this.renderStructureSummaryScreen,
		};

		const renderScreen = renderers[currentScreen] || this.renderComposerScreen;
		return renderScreen();
	};

	render() {
		return (
			<div className={styles.pageContainer}>
				<Sidebar />

				<div className={styles.glowTop} />
				<div className={styles.glowBottom} />

				<div className={styles.layoutShell}>
					{this.renderCurrentScreen()}
				</div>
			</div>
		);
	}
}
